import getCountryISO2 from 'country-iso-3-to-2';

import { reportAbTesterFailure } from 'src/dataLayer/remoteData/rollbar/reportAPIErrors';
import { getTrackingUUID } from 'src/dataLayer/localData/cookies';
import { LOCALE, GEO_DATA } from 'src/dataLayer/env';
import AbTesterWrapper from './AbTesterWrapper';

type ErrorType = {
  statusCode: number,
  message: string,
  name: string,
}

const isValidErrorResponse = (response: ErrorType): boolean =>
  [404, 422].includes(response.statusCode);

export default ({
  target,
  learnLang
}: {
  target: string,
  learnLang: string
}): Promise<string | undefined> => {
  // when no tracking uuid is set, we don't need to invoke ab tester
  if (!getTrackingUUID()) return undefined;

  const { countryCode3 } = GEO_DATA;
  const countryCodeAlpha2 = getCountryISO2(countryCode3);

  // TODO: we can remove the following line when we define the type for reportAbTesterFailure
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return AbTesterWrapper().get({ locale: LOCALE, target, learnLanguageAlpha3: learnLang, countryCodeAlpha2 })
    .then(
      ({ destination_value }) => {
        if (destination_value) return destination_value;
        throw new Error('The response structure of ab tester has changed');
      },
      (error: ErrorType) => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        if (!isValidErrorResponse(error)) reportAbTesterFailure(error);
        return undefined;
      }
    );
};
